import { UPDATE_PRESENT } from '@reduxLocal/actions/types';
import { isObject } from 'lodash';

export default function parseSchema(
	schema: Object,
	dispatch?: any
): Promise<Object> {
	return new Promise((resolve, reject) => {
		//Ensure schema meets criteria for parsing§
		if (schema === null || schema === undefined) {
			reject('Schema is null or undefined');
		}
		const schemaContent = schema?.schemaContent || schema?.schema;
		console.log('schema from function is', schema, schemaContent);

		//Strip any additional text and only extract the Array of Objects
		if (!isObject(schema)) {
			//Convert schema to object and ensure it meets requirements
			schema = JSON.parse(schema);
			if(schema?.error){
				reject("Error occurred parsing the schema", schema?.error);
			}
		} else {
			if (schema?.error) {
				reject('Failed to parse Schema', schema?.error);
			}
			//Ensure schema is an array of objects
			if (!Array.isArray(schemaContent)) {
				reject('Schema is not an array');
			}
		}
		console.log('passing forward the schema', schemaContent);
		//Extract schemaContent from schema
		if (dispatch) {
			dispatch({ type: UPDATE_PRESENT, payload: schemaContent });
			//Parse schema
			resolve(true);
		} else {
			resolve(schema);
		}
	});
}
